import { PluginManager } from './PluginManager';
import { PersistenceManager } from '../types/persistence-interfaces';
import { PersistenceManagerImpl } from '../persistence/PersistenceManagerImpl';
import { HistoryManager, HistoryConfig } from '../types/history-interfaces';
import { HistoryManagerImpl } from '../history/HistoryManagerImpl';
import { ReactivityManager, ReactivityConfig } from '../types/reactivity-interfaces';
import { ReactivityManagerImpl } from '../reactivity/ReactivityManagerImpl';
import { LiveQueryManager } from '../types/live-query-interfaces';
import { LiveQueryManagerImpl } from '../live-queries/LiveQueryManagerImpl';
import { GraphAlgorithmsManager } from '../types/graph-interfaces';
import { GraphAlgorithmsManagerImpl } from '../graph/GraphAlgorithmsManagerImpl';
import type { CSElement } from './CSElement';
import { ElementRegistry } from './ElementRegistry';

class ServiceRegistry {
  private _pluginManager: PluginManager;
  private _persistenceManager: PersistenceManager;
  private _historyManager: HistoryManager;
  private _reactivityManager: ReactivityManager;
  private _liveQueryManager: LiveQueryManager;
  private _graphAlgorithmsManager: GraphAlgorithmsManager;
  private _registry: ElementRegistry;

  constructor() {
    this._pluginManager = new PluginManager();
    this._persistenceManager = new PersistenceManagerImpl();
    this._historyManager = new HistoryManagerImpl();
    this._reactivityManager = new ReactivityManagerImpl();
    this._liveQueryManager = new LiveQueryManagerImpl();
    this._graphAlgorithmsManager = new GraphAlgorithmsManagerImpl();
    this._registry = new ElementRegistry();
  }

  public init(cselementClass: typeof CSElement) {
    // Решение проблемы циклической зависимости
    this._pluginManager.setCSElementClass(cselementClass);
    (this._liveQueryManager as LiveQueryManagerImpl).setCSElementClass(cselementClass);
    // GraphAlgorithmsManagerImpl не имеет прямой зависимости от статического класса CSElement
  }

  public get plugins(): PluginManager {
    return this._pluginManager;
  }

  public get persistence(): PersistenceManager {
    return this._persistenceManager;
  }

  public get history(): HistoryManager {
    return this._historyManager;
  }

  public get reactivity(): ReactivityManager {
    return this._reactivityManager;
  }

  public get liveQueries(): LiveQueryManager {
    return this._liveQueryManager;
  }

  public get graphAlgorithms(): GraphAlgorithmsManager {
    return this._graphAlgorithmsManager;
  }

  public get registry(): ElementRegistry {
    return this._registry;
  }
  
  public configureHistory(config: HistoryConfig): void {
    this._historyManager = new HistoryManagerImpl(config);
  }
  
  public configureReactivity(config: ReactivityConfig): void {
    this._reactivityManager = new ReactivityManagerImpl(config);
  }
}

export const services = new ServiceRegistry(); 